import React, { Component } from 'react';
import {
  Grid, Row, Col,
} from 'react-bootstrap';
import { Link } from 'react-router';

/** CUSTOM COMPONENTS **/
export class BoxTopContent extends Component{
  render(){
    return (
      <Col xs={12} md={12} className={'boxTopContent text-left'}>
        <Col xs={12} md={9}>
          <h2>Equipamentos de última geração, processos exclusivos e funcionais qualificados!</h2>
        </Col>
        <Col xs={12} md={3} className={'text-right'}>
          <Link
            to={'#'}
            className={'btn btn-lg btn-primary'}>
            Ver mais <i className={'fa fa-angle-right'}></i>
          </Link>
        </Col>
      </Col>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Site/BoxTopContent/BoxTopContent.js